import { render, staticRenderFns } from "./PDFTrace.vue?vue&type=template&id=3da33880"
import script from "./PDFTrace.vue?vue&type=script&lang=js"
export * from "./PDFTrace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports